export const selectTypeahead = (state) => state.typeahead;
